import React from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  FormControl,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { CARD_HELP_TEXT, CardHeadingWithHelp } from "../shared/help";

const BenefitsSection = ({
  canManagePayroll,
  benefitForm,
  setBenefitForm,
  adjustmentForm,
  setAdjustmentForm,
  employees,
  handleCreateBenefit,
  handleCreateAdjustment,
  benefits,
  adjustments,
  meta,
  formatPayrollCurrency,
}) => {
  return (
    <Stack spacing={6}>
      {canManagePayroll ? (
        <SimpleGrid columns={{ base: 1, xl: 2 }} spacing={6}>
          <Card>
            <CardHeader>
              <CardHeadingWithHelp
                title="Create Benefit"
                helpText={CARD_HELP_TEXT.createBenefit}
              />
            </CardHeader>
            <CardBody>
              <Stack spacing={3}>
                <FormControl>
                  <FormLabel>Employee</FormLabel>
                  <Select
                    value={benefitForm.userId}
                    onChange={(e) =>
                      setBenefitForm((prev) => ({
                        ...prev,
                        userId: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select employee</option>
                    {employees.map((employee) => (
                      <option key={employee._id} value={employee._id}>
                        {employee.name}
                      </option>
                    ))}
                  </Select>
                </FormControl>
                <FormControl>
                  <FormLabel>Type</FormLabel>
                  <Input
                    value={benefitForm.type}
                    onChange={(e) =>
                      setBenefitForm((prev) => ({
                        ...prev,
                        type: e.target.value,
                      }))
                    }
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Amount (Rupees)</FormLabel>
                  <Input
                    type="number"
                    value={benefitForm.amount}
                    onChange={(e) =>
                      setBenefitForm((prev) => ({
                        ...prev,
                        amount: e.target.value,
                      }))
                    }
                  />
                </FormControl>
                <SimpleGrid columns={2} spacing={3}>
                  <FormControl>
                    <FormLabel>Month</FormLabel>
                    <Input
                      type="number"
                      value={benefitForm.month}
                      onChange={(e) =>
                        setBenefitForm((prev) => ({
                          ...prev,
                          month: e.target.value,
                        }))
                      }
                    />
                  </FormControl>
                  <FormControl>
                    <FormLabel>Year</FormLabel>
                    <Input
                      type="number"
                      value={benefitForm.year}
                      onChange={(e) =>
                        setBenefitForm((prev) => ({
                          ...prev,
                          year: e.target.value,
                        }))
                      }
                    />
                  </FormControl>
                </SimpleGrid>
                <Button colorScheme="blue" onClick={handleCreateBenefit}>
                  Save Benefit
                </Button>
              </Stack>
            </CardBody>
          </Card>

          <Card>
            <CardHeader>
              <CardHeadingWithHelp
                title="Create Adjustment"
                helpText={CARD_HELP_TEXT.createAdjustment}
              />
            </CardHeader>
            <CardBody>
              <Stack spacing={3}>
                <FormControl>
                  <FormLabel>Employee</FormLabel>
                  <Select
                    value={adjustmentForm.userId}
                    onChange={(e) =>
                      setAdjustmentForm((prev) => ({
                        ...prev,
                        userId: e.target.value,
                      }))
                    }
                  >
                    <option value="">Select employee</option>
                    {employees.map((employee) => (
                      <option key={employee._id} value={employee._id}>
                        {employee.name}
                      </option>
                    ))}
                  </Select>
                </FormControl>
                <FormControl>
                  <FormLabel>Type</FormLabel>
                  <Select
                    value={adjustmentForm.type}
                    onChange={(e) =>
                      setAdjustmentForm((prev) => ({
                        ...prev,
                        type: e.target.value,
                      }))
                    }
                  >
                    <option value="BONUS">BONUS</option>
                    <option value="GRATUITY">GRATUITY</option>
                    <option value="ARREARS">ARREARS</option>
                  </Select>
                </FormControl>
                <FormControl>
                  <FormLabel>Amount (Rupees)</FormLabel>
                  <Input
                    type="number"
                    value={adjustmentForm.amount}
                    onChange={(e) =>
                      setAdjustmentForm((prev) => ({
                        ...prev,
                        amount: e.target.value,
                      }))
                    }
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Note</FormLabel>
                  <Input
                    value={adjustmentForm.note}
                    onChange={(e) =>
                      setAdjustmentForm((prev) => ({
                        ...prev,
                        note: e.target.value,
                      }))
                    }
                  />
                </FormControl>
                <Button colorScheme="blue" onClick={handleCreateAdjustment}>
                  Save Adjustment
                </Button>
              </Stack>
            </CardBody>
          </Card>
        </SimpleGrid>
      ) : null}

      <SimpleGrid columns={{ base: 1, xl: 2 }} spacing={6}>
        <Card>
          <CardHeader>
            <CardHeadingWithHelp
              title="Benefits"
              helpText={CARD_HELP_TEXT.benefits}
            />
          </CardHeader>
          <CardBody>
            <TableContainer>
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th>Employee</Th>
                    <Th>Type</Th>
                    <Th>Amount</Th>
                    <Th>Status</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {benefits.map((benefit) => (
                    <Tr key={benefit._id}>
                      <Td>{benefit.userId?.name || "-"}</Td>
                      <Td>{benefit.type}</Td>
                      <Td>{formatPayrollCurrency(benefit.amount, meta)}</Td>
                      <Td>
                        <Badge>{benefit.status}</Badge>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </CardBody>
        </Card>
        <Card>
          <CardHeader>
            <CardHeadingWithHelp
              title="Adjustments"
              helpText={CARD_HELP_TEXT.adjustments}
            />
          </CardHeader>
          <CardBody>
            <TableContainer>
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th>Employee</Th>
                    <Th>Type</Th>
                    <Th>Amount</Th>
                    <Th>Processed</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {adjustments.map((item) => (
                    <Tr key={item._id}>
                      <Td>{item.userId?.name || "-"}</Td>
                      <Td>{item.type}</Td>
                      <Td>{formatPayrollCurrency(item.amount, meta)}</Td>
                      <Td>
                        <Badge
                          colorScheme={item.isProcessed ? "green" : "orange"}
                        >
                          {item.isProcessed ? "Yes" : "No"}
                        </Badge>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </CardBody>
        </Card>
      </SimpleGrid>
    </Stack>
  );
};

export default BenefitsSection;
